import { createReducer } from '@reduxjs/toolkit'
import { unauthenticate, authenticate, refreshToken, dismissError } from '../actions/authentication';

export interface DataReducer {
    authenticating: boolean;
    token?: string;
    expiresOn?: number;
    authError?: string;
    nickname?: string;
}

const initialState: DataReducer = {
    authenticating: false
}

const dataReducer = createReducer<DataReducer>(initialState, (builder) => {
    builder.addCase(authenticate.pending, (state) => {
        state.token = undefined;
        state.authError = undefined;
        state.authenticating = true;
        console.log("Started authentication");
    });
    builder.addCase(authenticate.fulfilled, (state, action) => {
        state.token = action.payload?.token;
        state.nickname = action.payload?.nickname;
        state.expiresOn = action.payload?.expire;
        state.authenticating = false;
        console.log("Authentication done");
    });
    builder.addCase(authenticate.rejected, (state, action) => {
        state.authenticating = false;
        state.authError = action.error.message;
        console.log("Authentication rejected");
    });
    builder.addCase(refreshToken.pending, () => {
        //state.authenticating = true;
        console.log("Refreshing authentication");
    });
    builder.addCase(refreshToken.fulfilled, (state, action) => {
        state.token = action.payload?.token;
        state.nickname = action.payload?.nickname;
        state.expiresOn = action.payload?.expire;
        state.authenticating = false;
        console.log("Refresh done");
    });
    builder.addCase(refreshToken.rejected, (state, action) => {
        state.authenticating = false;
        state.authError = action.error.message;
        state.token = undefined;
        state.authError = undefined;
        console.log("Refresh rejected");
    });
    builder.addCase(unauthenticate.pending, (state) => {
        state.authenticating = true;
        console.log("Started unauthentication");
    });
    builder.addCase(unauthenticate.fulfilled, (state) => {
        state.token = undefined;
        state.nickname = undefined;
        state.expiresOn = undefined;
        state.authenticating = false;
        console.log("Unauthentication done");
    });
    builder.addCase(unauthenticate.rejected, (state, action) => {
        state.authenticating = false;
        state.authError = action.error.message;
        console.log("Unauthentication rejected");
    });
    builder.addCase(dismissError, (state) => {
        state.authError = undefined;
    });
});

export default dataReducer;
